/*globals $ */

import Quiz from './Quiz';

class Scene {
  constructor(sceneManager, $container) {
    this.sceneManager = sceneManager;
    this.$container = $container;
    this.id = this.$container.attr('data-scene');
    // console.log('Scene - ', this.id);

    if(this.$container.find('.Quiz')) {
      this.quiz = new Quiz(this.$container.find('.Quiz'), this.sceneManager);
    }

    this.isFadein = false;
  }

  fadein(currentQuiz = -1) {
    /*
    if(this.id == 'result') {
      console.log('正解数は', this.sceneManager.correctCount);
    }
    */
    if(!this.isFadein) {
      this.isFadein = true;
      if(currentQuiz != -1) {
        this.$container.attr('data-quiz-count', currentQuiz);
      }
      if(this.id == 'result') {

        let rank = 'S';
        if(this.sceneManager.correctCount < 3) rank = 'B';
        else if(this.sceneManager.correctCount < 5) rank = 'A';

        let rankTitle = 'マイスター';
        if(rank == 'B') {
          rankTitle = '見習い';
        } else if(rank == 'A') {
          rankTitle = '職人';
        }
        // console.log('シェアされるランクは' + rank + 'です');
        let url_twitter = 'http://twitter.com/share?';
        let param_twitter = {
          'url': 'https://www.kai-group.com/fun/event/edgemuseum/sound/?score=' + this.sceneManager.correctCount,
          'via': 'kai_corporation',
          'text': 'あなたはKAI Sound ' + rankTitle + 'です！ みんなもKAI Sound Labに挑戦しませんか？',
          'hashtags': '貝印,いい刃の日,' + rank + 'ランク'
        };

        Object.keys(param_twitter).forEach(function (key) {
          url_twitter += key + '=' + encodeURIComponent(param_twitter[key]) + '&';
        });

        $('#btn-share-result').attr('href', url_twitter);

        this.$container.attr('data-correct-count', this.sceneManager.correctCount);
      }
      this.$container.css('display', 'block');
      window.scrollTo(0, 0);
      setTimeout(() => {

        this.$container.addClass('-fadein');
      }, 40);
    }
  }

  fadeout() {
    if(this.isFadein) {
      this.isFadein = false;
      this.$container.css('display', 'none');
      this.$container.removeClass('-fadein');
    }
  }

  reset() {
    this.fadeout();

    if(this.$container.find('.Quiz')) {
      this.quiz.reset();// = new Quiz(this.$container.find('.Quiz'), this.sceneManager);
    }
  }
}

export default Scene;
